<template>
    <div class="invoice-summary-container row mb-4">
        <div class="col-12 col-sm-6 col-lg-3 mb-3 mb-lg-0" v-for="(card, index) in cards" :key="index">
            <invoice-card
                :label="card.label"
                :value="card.value"
                :sub-value="card.subValue"
                :icon="card.icon"
                :color="card.color"
            />
        </div>
    </div>
</template>

<script>
import InvoiceCard from "./invoice-card.vue";
import { formatCurrency } from "../helpers";

export default {
    name: "invoice-summary-cards",
    components: {
        InvoiceCard
    },
    props: {
        summary: {
            type: Object,
            default: () => ({
                total_invoices: 0,
                awaiting_payment_count: 0,
                awaiting_payment_value: 0,
                paid_count: 0,
                paid_value: 0,
                total_revenue: 0
            })
        }
    },
    computed: {
        cards() {
            const s = this.summary || {};
            return [
                {
                    label:    this.t('invoices-status_overdue_label'),
                    value:    this.formatCurrency(s.overdue_value),
                    subValue: this.t('invoices-n_invoices').replace('{count}', s.overdue_count || 0),
                    icon:     "fa-exclamation-triangle",
                    color:    "#EF4444"
                },
                {
                    label:    this.t('invoices-status_pending'),
                    value:    this.formatCurrency(s.pending_value),
                    subValue: this.t('invoices-n_invoices').replace('{count}', s.pending_count || 0),
                    icon:     "fa-clock-o",
                    color:    "#F59E0B"
                },
                {
                    label:    this.t('invoices-status_paid'),
                    value:    this.formatCurrency(s.paid_value),
                    subValue: this.t('invoices-n_invoices').replace('{count}', s.paid_count || 0),
                    icon:     "fa-check-circle",
                    color:    "#2AAA4C"
                },
                {
                    label:    this.t('invoices-total'),
                    value:    this.formatCurrency(s.total_active_value),
                    subValue: this.t('invoices-n_invoices').replace('{count}', s.total_active_count || 0),
                    icon:     "fa-bar-chart",
                    color:    "#2AAA4C"
                }
            ];
        }
    },
    methods: {
        formatCurrency
    }
};
</script>
